module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epigraph.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-26"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }), _c('span', {
    staticClass: "bold-italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Many things grow in the garden that were\n\t\t\t\t\t\tnever sown there"), _c('br'), _vm._v("—Thomas Fuller,")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Gnomologia, 1732")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Worry gives a small thing a big\n\t\t\t\t\t\tshadow"), _c('br')]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("—Swedish proverb")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-21"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eba9634","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epigraph.vue
// module id = 69
// module chunks = 0